import { applyMiddleware, compose } from "redux";
import ReduxThunk from "redux-thunk";
import { routerMiddleware } from "connected-react-router";
import { createLogger } from "redux-logger";

export const assembleMiddleware = (history) => {
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  return composeEnhancers(
    applyMiddleware(routerMiddleware(history), ReduxThunk, createLogger())
  );
};

export default assembleMiddleware;
